import styled from "styled-components";

import { device } from "../../devices";
import { DrawerAreaWrapper } from "../common/Drawer/Area/DrawerAreaWrapper";

const SettingsDrawerAreaWrapper = styled(DrawerAreaWrapper)`
  @media ${device.mobileScreen} {
    padding: 1rem 1.5rem 0 1.5rem;
  }
`;

export { SettingsDrawerAreaWrapper };
